/*
 * @Author: Teemo Ding
 * @Date: 2021-11-25 14:34:53
 * @LastEditTime: 2022-01-30 15:09:13
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/AdditionalItem/index.tsx
 */
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';

import Additional from '../../../Components/Additional';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const AdditionalItem = ({
  salesChannelUuid,
  orderUuid,
  onUpdate,
  disable,
  currency,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      title={getI18n('allOrders.orderDetail.additionalitem')}
      subtitle={getI18n(
        'allOrders.orderDetail.additionalItemCategory_return_SectionWrapper_subtitleyes',
      )}>
      <Additional
        salesChannelUuid={salesChannelUuid}
        orderUuid={orderUuid}
        currency={currency}
        disable={disable}
        onSave={onUpdate}
        //rowKey={'productUuid'}
      />
    </SectionWrapper>
  );
};

export default AdditionalItem;
